import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';

export const useSellerIsInTrial = () => {
  const subscriptionPlanInfo = useSelector(Global.selectSellerSubscriptionPlanInfo);

  if (!subscriptionPlanInfo) {
    return false;
  }

  if (subscriptionPlanInfo.planCode && subscriptionPlanInfo.planCode.toLowerCase() !== 'trial') {
    return false;
  }

  if (subscriptionPlanInfo.isExpired === undefined || subscriptionPlanInfo.isExpired === null) {
    return false;
  }

  return !subscriptionPlanInfo.isExpired;
};
